import axios from "axios";
const { REACT_APP_DEBUGGER_SERVER_URL } = process.env;

export const API = axios.create({
  baseURL: REACT_APP_DEBUGGER_SERVER_URL,
  withCredentials: true,
});

//example request
export const createUser = (name) => API.post("/user", name);

export const createTeacher = (name) => API.post("/teacher", name);

export const createClass = (name) => API.post("/classes", name);

export const createAssignment = (assignment, userID) =>
  API.post("/assignment", { assignment: assignment, userID: userID });

export const updateAssignment = (assignmentID, assignment) =>
  API.post("/assignment/" + assignmentID, { assignment: assignment });

export const updateAssignmentQuestions = (assignmentID, questions) =>
  API.post("/assignment/set-questions/" + assignmentID, {
    questions: questions,
  });

export const copyAssignment = (assignmentID, userID) =>
  API.post("/assignment/copy/" + assignmentID, { userID: userID });

export const fetchQuestion = async (questionID) =>
  await API.get("/question/" + questionID);

export const updateQuestion = (question) =>
  API.put("/question", { question: question });

export const fetchUser = (jwt) => API.post("/user", { jwt: jwt });

export const updateUser = (name, email, isTeacher) =>
  API.post("user/update", { name: name, email: email, isTeacher: isTeacher });

export const fetchUserByID = (userID) => API.get("/user/" + userID);

export const fetchClass = (classID) => API.get("/classes/" + classID);

export const deleteClass = (classID) => API.delete("/classes/" + classID);

export const fetchAssignment = (assignmentID) =>
  API.get("/assignment/" + assignmentID);

export const addAssignment = (classID, assignmentID, assigned_date) =>
  API.post("/classes/add-assignment/" + classID, {
    assignmentID: assignmentID,
    assigned_date: assigned_date
  });

export const removeAssignment = (classID, assignmentID) =>
  API.post("/classes/remove-assignment/" + classID, {
    assignmentID: assignmentID,
  });

export const removeStudent = (classID, studentID) =>
  API.post("/classes/remove-student/" + classID, { studentID: studentID });

export const deleteAssignment = (userID, assignmentID) =>
  API.post("/user/delete-assignment/" + userID, { assignmentID: assignmentID });

export const joinClass = (userID, classID) =>
  API.post("/user/join", { userID: userID, classID: classID });

export const submitAssignment = (userID, assignmentID) =>
  API.post("/assignment/submit/" + assignmentID, { userID: userID });

export const saveAnswer = (
  userID,
  assignmentID,
  questionID,
  grade,
  studentAnswer,
  testResults
) =>
  API.post("/user/save", {
    userID: userID,
    assignmentID: assignmentID,
    questionID: questionID,
    grade: grade,
    studentAnswer: studentAnswer,
    testResults: testResults,
  });
